<template>
  <div class="regulation">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, i) in tabList"
        :key="i"
        :label="item.label"
        :name="item.name"
      >
        <div
          class="regulation_list"
          v-for="(item, index) of regulationData"
          :key="index"
        >
          <div class="text_detail" @click="pageJump(item)">
            {{ item.fileName }}
          </div>
          <div class="download_button">
            <span>{{ item.publishDate }}</span>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- <div class="regulation_title">注册法规</div> -->
    <!-- <div class="regulation_list" v-for="(item,index) of regulationData" :key="index">
      <div class="text_detail" @click="pageJump(item)">{{item.fileName}}</div>
    </div>
    <pdf-view :dialogVisible="dialogVisible" @closeDialog="clos
    eDialog" :path="path"></pdf-view> -->
    <!-- pdf的文件显示 -->
    <LawsDetail
      style="margin-top:45px;padding:20px;height:calc(100% - 65px)"
      v-loading="loading"
      :url="url"
      v-if="this.dialogVisible"
    />
  </div>
</template>

<script>
9;
import { townServiceList, imgSrcGetBase64,getBlobPDF} from "common/js/api";
// import PdfView from "./components/pdfView";
import LawsDetail from "./LawsDetail";
export default {
  name: "Laws",

  components: {
    // PdfView,
    LawsDetail,
  },

  data() {
    return {
      activeName: "REDUCED_POLICY",
      regulationData: [],
      dialogVisible: false,
      path: "",
      tabList: [
        {
          label: "优惠政策",
          name: "REDUCED_POLICY",
        },
        {
          label: "法律法规",
          name: "LAW_POLICY",
        },
        {
          label: "部门规章",
          name: "DEPARTMEN_POLICY",
        },
        {
          label: "自律规则",
          name: "SELF_POLICY",
        },
      ],
      name: "REDUCED_POLICY",
      pdfDoc: null,
      loading: false,
      time: null,
    };
  },

  created() {
    this.getView();
  },
  methods: {
    //返回列表页
    pdfClick() {
      this.dialogVisible = false;
    },
    handleClick(tab, event) {
      this.name = tab.name;
      this.dialogVisible = false;
      this.url = "";
      this.getView();
    },
    closeDialog() {
      this.dialogVisible = false;
    },

    async pageJump(item) {
      if (this.time) {
      }
      this.dialogVisible = true;
      this.loading = true;
      this.time = setTimeout(() => {
        if (this.loading === true) {
          this.loading === false;
        }
      }, 20000);
      let a = await getBlobPDF(item.filePath);
      const result = URL.createObjectURL(a);
      this.loading = false;
      this.url = result;
    },

    async getView() {
      // const name = "LAW_POLICY";
      const { result } = await townServiceList(this.name);
      this.regulationData = result;
      this.regulationData.map((item) => {
        item.fileName = item.fileName.split(".")[0];
      });
      this.regulationData.sort((a, b) => {
        return new Date(b.publishDate) - new Date(a.publishDate);
      });
    },
  },
};
</script>

<style>
.regulation_title {
  border-left: 8px solid #3165ff;
  font-size: 24px;
  color: #0f1824;
  font-weight: bold;
  padding-left: 10px;
  margin: 0 0 15px;
}
.regulation_list {
  /* height: 87px; */
  line-height: 87px;
  border-bottom: 1px solid #eeeeee;
  position: relative;
}
.text_detail:hover {
  color: #3165ff;
}
.text_detail {
  cursor: pointer;
  font-size: 20px;
  color: #0f1824;
  max-width: 80%;
}
.download_button {
  position: absolute;
  right: 15px;
  top: -2px;
}
.download_button span {
  color: #b6bcc2;
}
.el-tabs__item {
  color: #6c7885 !important;
}
</style>
